// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-libs_core_src_lib_services_date_date_service_ts-libs_core_src_lib_tokens_unleash-flag-7c23a5":"5a219d48f7bd8df5","libs_wl_westpac_src_lib_gift-card_gift-card-wrapper_module_ts":"b0f414f7813e0ac5","apps_stg_src_app_offer_offer-wrapper_module_ts":"f5713cfd164f2e69"}[chunkId] + ".js";
};